import React from 'react';
import { Button, Card, Table } from 'react-bootstrap';

import { ProjectCostCompanyRoleRate } from '../../../../types';
import { useTypedProjectCostContext } from '../../useTypedProjectCostContext';
import TableControls from '../TableControls';
import { formatCurrencyFromCents } from '../../utils';

type CompanyRoleRatesTableProps = {
  companyId?: number;
  hideCompanyColumn?: boolean;
};

const CompanyRoleRatesTable: React.FC<CompanyRoleRatesTableProps> = ({ companyId, hideCompanyColumn = false }) => {
  const {
    getPagedCompanyRoleRates,
    handleEditCompanyRoleRate,
    handleDelete,
    saving,
  } = useTypedProjectCostContext<{
    getPagedCompanyRoleRates: (companyId?: number | null) => {
      pageItems: ProjectCostCompanyRoleRate[];
      totalItems: number;
      totalPages: number;
      currentPage: number;
    };
    handleEditCompanyRoleRate: (item: ProjectCostCompanyRoleRate) => void;
    handleDelete: (path: string, message: string) => Promise<void>;
    saving: boolean;
  }>();

  const paged = getPagedCompanyRoleRates(companyId ?? null);
  const colSpan = hideCompanyColumn ? 5 : 6;

  return (
    <Card>
      <Card.Header>Regras de taxa por empresa + função</Card.Header>
      <Card.Body className="table-responsive">
        <TableControls
          tableKey="companyRoleRates"
          placeholder="Buscar por empresa, função, período, observações..."
          totalItems={paged.totalItems}
          totalPages={paged.totalPages}
          currentPage={paged.currentPage}
        />
        <Table size="sm" hover>
          <thead>
            <tr>
              {!hideCompanyColumn && <th>Empresa</th>}
              <th>Função</th>
              <th>Taxa/h</th>
              <th>Início</th>
              <th>Fim</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {paged.pageItems.length === 0 ? (
              <tr>
                <td colSpan={colSpan} className="text-center text-muted py-3">
                  Nenhum registro encontrado.
                </td>
              </tr>
            ) : (
              paged.pageItems.map((item) => (
                <tr key={item.id}>
                  {!hideCompanyColumn && <td>{item.company?.name || item.company_id}</td>}
                  <td>{item.role?.name || item.role_id}</td>
                  <td>{formatCurrencyFromCents(item.hourly_rate)}</td>
                  <td>{item.effective_start || '—'}</td>
                  <td>{item.effective_end || '—'}</td>
                  <td>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="me-2"
                      onClick={() => handleEditCompanyRoleRate(item)}
                      disabled={saving}
                    >
                      Editar
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => void handleDelete(
                        `/api/projects/costs/company-role-rates/${item.id}`,
                        'Excluir regra de taxa?',
                      )}
                      disabled={saving}
                    >
                      Excluir
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default CompanyRoleRatesTable;
